// extracted by mini-css-extract-plugin
export var header = "Header-module--header--Kmy2n";
export var title = "Header-module--title--3lmQ6";
export var subtitle = "Header-module--subtitle--1LTYp";